"use strict";
angular.module("recentlyRankModule", [])
    .controller("recentlyRankCtrl", ["$scope", "$rootScope", "$modalInstance", "$state", "$filter", "trsHttpService", "modalDialog", "$timeout", "$compile", "commandService", "$q","datas",
        function($scope, $rootScope, $modalInstance, $state, $filter, trsHttpService, modalDialog, $timeout, $compile, commandService , $q,datas) {
            initStatus();
            initData();
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status={
                    entity:datas.item.entity,
                    category:datas.item.category,
                    recentlysDay:0,
                };
            }
            /**
             * [initCreate description] 初始化新建数据
             * @return {[type]} [description]
             */
            function initData() {
                initCharts();
            };
            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData(){
                var defer=$q.defer();
                var params={
                    typeid: 'event',
                    serviceid: 'eventtrace',
                    modelid:'getrank',
                    eventid:$state.params.id,
                    entity:$scope.status.entity,
                    category:$scope.status.category,
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "GET").then(function(data) {
                   defer.resolve(data);
                });
                return defer.promise;
            };
            /**
             * [initCharts description] 初始化echart
             * @return {[type]} [description]
             */
            function initCharts(){
                requestData().then(function(data){
                    $scope.status.recentlysDay=data.TIME;
                    var rank=data.RANK;
                    $scope.xaxisData=[];$scope.yaxisData=[];
                    for(var i=0;i<rank.length;i++){
                        if(!rank[i].RANK){
                            rank[i].RANK=10;
                        }
                        $scope.xaxisData.push($filter('date')(new Date(rank[i].PUBTIME), 'yyyy-MM-dd'));
                        $scope.yaxisData.push(parseInt(rank[i].RANK));
                    }
                    var option = {
                        backgroundColor: '#fff',
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'none',
                            },
                            formatter:function(value){
                                var arrData=['一','二','三','四','五','六','七','八','九','十'];
                                var data='第'+arrData[value[0].data-1]+'名';
                                return data;
                            },
                        },
                        xAxis: [{
                            name:"(日期)",
                            boundaryGap: true,
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#dbdbdb',
                                    fontSize:14,
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#2a2a2a'
                                }
                            },
                            data:$scope.xaxisData,
                        }],
                        yAxis: [{
                            type: 'value',
                            name: '(名次)',
                            nameLocation:'start',
                            interval:1,
                            min:1,
                            max:10,
                            inverse:true,
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#dbdbdb',
                                    fontSize:14,
                                }
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                    fontSize: 14,
                                    color: '#2a2a2a'
                                },
                                position:'top',
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#eaeff2',
                                    type: 'dash',
                                }
                            }
                        }],
                        series: [{
                            name: '名次',
                            type: 'line',
                            symbol: 'circle',
                            symbolSize: 6,
                            lineStyle: {
                                normal: {
                                    width: 1
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#3080ff',
                                    borderColor: '#b0cefb',
                                    borderWidth: 10

                                }
                            },
                            data: $scope.yaxisData,
                        },]
                    };
                    $timeout(function(){
                        require(['echarts'], function(echarts) {
                            var myChart = echarts.init($(".recently-rank-line-chart")[0]);
                            myChart.setOption(option);
                        });
                    })
                });
            }
            /**
             * [close description] 关闭弹框
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };


        }
    ]);